(function ($) {
  'use strict';

  /**
   * Badge Spinner Playback Controls
   */

  // Get 'Reduced Motion' Preference
  var mql = window.matchMedia('(prefers-reduced-motion: reduce)');
  var is_reduced_motion = mql === true || mql.matches === true;

  var $badge_playback_button = $('.js-badge-playback-control');

  // Setup badge playback controls
  $badge_playback_button.each(function () {
    var $this = $(this);
    var $this_control_label = $this.find( '.js-video-playback-control-label' );
    // Translated labels from data attrs
    var label_is_paused = $this.data( 'label-is-paused' );
    var label_is_playing = $this.data( 'label-is-playing' );
    // Get Animation El
    var $this_badge = $( '#' + $this.attr( 'aria-controls' ) );

    // Start paused if reduced motion is set
    if ( is_reduced_motion ) {
      $this.attr( 'data-is-playing', 'false' );
      $this_control_label.text( label_is_paused );
      $this_badge.addClass( 'is-badge-paused' );
    }

    $this.on('click', function () {
      var is_paused = $this_badge.hasClass( 'is-badge-paused' );

      // Play animation
      if ( is_paused ) {
        $this.attr( 'data-is-playing', 'true' );
        $this_badge.removeClass( 'is-badge-paused' );
        $this_control_label.text( label_is_playing );

      // Pause Animation
      } else {
        $this.attr( 'data-is-playing', 'false' );
        $this_badge.addClass( 'is-badge-paused' );
        $this_control_label.text( label_is_paused );
      }
    });

  });

})(jQuery);
